// =============================================================================
// APP — ROUTING
// -----------------------------------------------------------------------------
// Diese Datei ist absichtlich kurz: sie macht NUR das Routing.
// Bearbeitbare Inhalte (Texte, Links, Termine) findest du in: src/config.js
// Einzelne Seiten:    src/components/{Home,Impressum,Datenschutz}.jsx
// Animation/Layout:   src/App.css
// =============================================================================

import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/components/Home";
import Impressum from "@/components/Impressum";
import Datenschutz from "@/components/Datenschutz";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </BrowserRouter>
  );
}
